import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import * as ReactRedux from 'react-redux'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {CSSProperties} from 'react'
import {RealCampusArtEdit} from './RealCampusArtEdit'
import {RealCampusProductEdit} from './RealCampusProductEdit'
import {RealCampusProofInfo} from './RealCampusProofInfo'
import {RealCampusTextEdit} from './RealCampusTextEdit'
import {Message} from '../Components/Message'
import {RealCampusFooter} from './RealCampusFooter'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import {RealCampusHdr} from './RealCampusHdr';
import {RealCampusFeedback} from './RealCampusFeedback';
import { ProofConfirmationEmailToggle } from '../Components/ProofConfirmationEmailToggle';

const proofEditStyle : CSSProperties = {
    position: 'relative',
    height:'auto',
    width:'100%',
}
const editZoneStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin:'auto'
}
let submitBtnStyle : CSSProperties = {
    backgroundColor:'#5E6A74',
    color:'white',
    width:'529px',
    height:'49px',
    margin:'auto',
    textAlign:'center',
    lineHeight:'3.2em',
    fontFamily:'Reitam',
    cursor:'pointer',
    letterSpacing:'0.2em',
    fontSize:'15px',
    ':hover': {
        backgroundColor:'white',
        color:'#5E6A74',
        border:'1px solid #5E6A74'
    }
}

const hdrDiv: CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifRegular',
    marginTop:'15px'
}

const lines:React.CSSProperties = {
    width:'980px',
    borderBottom:'1px solid #EEEDED',
    margin:'15px auto'
}
const lineCont: React.CSSProperties = {
    margin:'110px'
}

const hrdText: React.CSSProperties = {
    color:'rgba(66, 66, 66, 0.8)',
    fontSize:'25px',
    textTransform:'uppercase',
    letterSpacing:'1px',
    fontFamily:'Lulo'
}



let errorStyle=Object.assign({}, Tgcc.Styles.error, {fontSize:'20px', marginBottom: '5px'});

class StateType {
    password: string;
    confirmPassword: string;
    error: string;
    isWaiting: boolean;
    proofId: string;
    uploadedFiles: any;
    finished: boolean;
}

const  isBlankOrEmpty = (str: string) => {
    if(!str)
        return true;
    if(!str.trim())
        return true;
    return false;
}


class _RealCampusProofEdit extends React.Component<Tgcc.BaseProps, any>{

    state: StateType = new StateType();
    preferenceToggleRef: React.RefObject<ProofConfirmationEmailToggle> = React.createRef();

    componentWillMount(){
        this.state.uploadedFiles = [];
        if(!this.props.state.ActiveProof){
            var newProof = new Tgcc.Proof();
            newProof.phone = this.props.state.UserInfo.phone;
            newProof.smsAllowed = this.props.state.UserInfo.smsAllowed;
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: newProof});
        }

        if(this.props && this.props.location && this.props.location.query){
            var designId = this.props.location.query.designId;
            if(designId)
                Request.getDesign(designId, this.designFound, () => {});
            var brand = this.props.location.query.brand;
            var style = this.props.location.query.style;
            var color = this.props.location.query.color;
            if(brand && style && color)
                Request.getProduct(brand, style, color, this.productFound, ()=>{});
        }
        if(this.props.location.query.code){
            this.props.dispatch({type: Tgcc.StateAction.UpdateProofNotes, payload: this.props.location.query.code});
        }
    }

    designFound = (design: Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofDesign, payload: design});
        browserHistory.replace(Tgcc.Routes.CampusProofEdit);
    }

    productFound = (product: Tgcc.Product) =>{
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofProduct, payload: product});
        browserHistory.replace(Tgcc.Routes.CampusProofEdit);
    }

    componentDidMount(){
        var tag = document.getElementById('proof');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }

    validatePasswords = () => {
        if(!this.state.password || !this.state.password.trim())
            return this.setError('Password cannot be blank');
        if(!this.state.confirmPassword)
            return this.setError('Passwords do not match');
        if(this.state.password.trim() != this.state.confirmPassword.trim())
            return this.setError('Passwords do not match');
        return true;
    }

    allDone = () => {

    }

    registerNewUser = ( onSuccess: (login: Tgcc.LoginData, user: Tgcc.UserInfo) => void) => {
        var user = this.props.state.UserInfo;
        if(!user.firstName || !user.firstName.trim())
            this.setError('First Name cannot be blank');
        else if(!user.lastName || !user.lastName.trim())
            this.setError('Last Name cannot be blank');
        else if(!user.email || !user.email.trim())
            this.setError('Email cannot be blank');
        else if(!this.state.password || !this.state.password.trim())
            this.setError('Password cannot be blank');
        else if(this.state.password != this.state.confirmPassword)
            this.setError('Passwords do not match');
        else {
            this.setState({isWaiting: true});
            Request.registerUser(user, this.state.password, this.state.confirmPassword,
                (newUser: Tgcc.UserInfo) => {
                    Request.loginUser(user.email, this.state.password,
                        (ld: Tgcc.LoginData) => {
                            this.props.dispatch({type: Tgcc.StateAction.Login, payload: ld}); 
                            this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: user}); 
                            onSuccess(ld, user);
                        },
                        (err: string) => {})
                },
                this.setError);
        }
    }

    saveProofRequest = (loginData: Tgcc.LoginData, proof: Tgcc.Proof) => {
        var email = loginData.username;
        this.setState({isWaiting: true});
        var setDate = new Date(proof.inHandsDate)
        setDate.setHours(setDate.getHours() +4)
        proof.inHandsDate = this.formatinHandsDate(setDate)
        Request.createCampusProofRequest(email, loginData, proof, this.proofComplete, (err) =>{
            this.setError(err);
        });
    }

    proofComplete = (proof: Tgcc.Proof) => {
        this.setState({finished: true, proofId: proof.proofId});
    }

    updateUserInfo = (user: Tgcc.UserInfo) => {
        Request.updateUser(this.props.state.LoginData, user, 
            (userData: Tgcc.UserInfo) => {
                this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: userData});
            },
            () => {}
        );
    }

    successfulRegistration = (login: Tgcc.LoginData,  uData: Tgcc.UserInfo) => {
        Tgcc.successfulLogin(this.props.dispatch, login)
        this.updateUserInfo(uData)
        this.saveProofRequest(login, this.props.state.ActiveProof);
    }

    formatDate = (date:Date,days:number) => {
        var monthNames = [
            "01", "02", "03",
            "04", "05", "06", "07",
            "08", "09", "10",
            "11", "12"
        ];
        var day = date.getDate() + days;
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        var today = year + '-' + monthNames[monthIndex] + '-' + day;

        return today;
}

formatinHandsDate = (date:Date) => {
    var monthNames = [
        "01", "02", "03",
        "04", "05", "06", "07",
        "08", "09", "10",
        "11", "12"
    ];

    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var today = year + '-' + monthNames[monthIndex] + '-' + day;

    return today;
}
    validateQuantity = () => {
        var proof = this.props.state.ActiveProof;
        var today = this.formatDate(new Date(),5)
        if( proof.screenPrint && proof.orderSize < 24){
            return this.setError("Minimum order size is 24");
        }
        if( proof.embroidery && proof.orderSize < 24){
            return this.setError("Minimum order size is 24");
        }
        if( !proof.embroidery && !proof.screenPrint && proof.orderSize < 24){
            return this.setError("Minimum order size is 24");
        }
        if (!proof.orderSize){
            return this.setError("Please provide an order quantity");
        }
        if(new Date(proof.inHandsDate) == new Date(today)){
            return this.setError("Must be later")
        }
        return true;
    }

    validateUser = () => {
        if(!this.props.state.UserInfo)
            return this.setError("Please login or register");

        var user = this.props.state.UserInfo;
        
        // Check if CSR is impersonating - if so, bypass profile requirements
        const isImpersonating = this.props.state.LoginData && this.props.state.LoginData.impersonate;
        
        if(isImpersonating) {
            // Only validate email for impersonated users
            if(isBlankOrEmpty(user.email))
                return this.setError("Email address cannot be null");
            if(!Tgcc.IsValidEmail(user.email))
                return this.setError("Email is not valid");
            return true;
        }
        
        // Full validation for regular users
        if(isBlankOrEmpty(user.email||user.firstName||user.lastName||user.email||user.phone))
            return this.setError("Please login or register");
        if(isBlankOrEmpty(user.email))
            return this.setError("Email address cannot be null");
        if(!Tgcc.IsValidEmail(user.email))
            return this.setError("Email is not valid");
        if(isBlankOrEmpty(user.firstName) || isBlankOrEmpty(user.lastName))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your first name and last name.");
        if(isBlankOrEmpty(user.phone))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your phone number.");
        if(isBlankOrEmpty(user.address))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your address.");
        if(isBlankOrEmpty(user.city))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your city.");
        if(isBlankOrEmpty(user.state))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your state.");
        if(isBlankOrEmpty(user.zip))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your zip code.");
        if(!Tgcc.IsValidPhoneNumber(user.phone))
            return this.setError("Please enter a valid phone number. Go to your Dashboard to update your phone number.");
        return true;
    }
    validateDate = () => {
        if(isBlankOrEmpty(this.props.state.ActiveProof.inHandsDate)){
            return this.setError("In Hands Date cannot be blank")
        }
        return true;
    }

    submitProofRequest = () => {
        this.setState({error: null, isWaiting: true});

        if(!this.props.state.UserInfo){
            return this.setError("Please log in or register");
        }
        if(!this.validateDate())
            return

        if(!this.validateUser())
            return;

        if(!this.validateQuantity())
            return;
            
        if(!this.props.state.LoginData){
            if(!this.validatePasswords())
                return;
            this.registerNewUser( this.successfulRegistration );
        } else {
            var ld = this.props.state.LoginData;
            var proof = this.props.state.ActiveProof;
            this.updateUserInfo(this.props.state.UserInfo);
            this.saveProofRequest(ld, proof);
        }
    }

    // Add method to handle preference update before proof submission
    updateUserPreferenceAndSubmit = async () => {
        try {
            // Update the user's proof confirmation email preference
            if (this.preferenceToggleRef.current) {
                await this.preferenceToggleRef.current.updateUserPreference();
            }
            
            // Then proceed with normal proof submission
            this.submitProofRequest();
        } catch (error) {
            console.error('Failed to update preference:', error);
            // Continue with proof submission even if preference update fails
            this.submitProofRequest();
        }
    }

    whenFinished = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof})
        browserHistory.push(Tgcc.Routes.RealCampusDashboard);
    }

    getThankYou = () => {
        return <Message 
            Title="Thank You!"         
            UseTitleScript={true}
            Message1="Your proof request has been received."
            Message2={"Proof Number: " + this.state.proofId}
            onContinue={this.whenFinished}
            btnStyle='#5E6A74'
        />
    }
    getProofEditHeader(){
        return (
            <div style={hdrDiv} className="realcampusProfHdr">
                <div style={hrdText}>Let's get started customizing your order!</div>
            </div>
        )
    }
    getHrzLines() {
        return (
            <div style={lineCont}>
                <div style={lines}></div>
            </div>
        )
    }

    render() {
        var submitBtn = this.state.isWaiting ? Tgcc.workingGif : <div style={submitBtnStyle} onClick={this.updateUserPreferenceAndSubmit} className="campusSubmit">Submit Request</div>
        var thankYou = this.state.finished ? this.getThankYou() : null;
        return (
            <div style={proofEditStyle}>
            <div id="proof"></div>
            <RealCampusHdr />
            <RealCampusFeedback state={this.props.state} />
            {this.getProofEditHeader()}
            <RealCampusProofInfo />
                <div style={editZoneStyle} className='campusEditZone'>
                    <RealCampusArtEdit />
                    <RealCampusTextEdit state={this.props.state}/>
                    <RealCampusProductEdit state={this.props.state}/>
                </div>
                <div id="TopProofError" style={errorStyle}>{this.state.error}</div>               
                <ProofConfirmationEmailToggle 
                    state={this.props.state} 
                    dispatch={this.props.dispatch}
                    ref={this.preferenceToggleRef}
                />
                {submitBtn}
                {this.getHrzLines()}
                <RealCampusFooter state={this.props.state} />
                {thankYou}
            </div>
        );
    }   
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state };
};
export var RealCampusProofEdit = connect(mapStateToProps)(Radium(_RealCampusProofEdit));

